export default "__VITE_ASSET__Gzhu8hIN__"